/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Ce } from './Ce';

class DeferredReviewApply extends Ce {
    constructor() {
        super();
        this.baseUrl += '/deferredReviewApply';
    }

    findDeferredReviewApplyList(queryData) {
        let applyTimeBegin = null;
        let applyTimeEnd = null;
        if (queryData.applyTime != null && queryData.applyTime.length === 2) {
            [applyTimeBegin, applyTimeEnd] = queryData.applyTime;
        }
        return super.get('/findDeferredReviewApplyList', {
            ...queryData,
            applyTimeBegin,
            applyTimeEnd,
        });
    }

    getDeferredReviewApplyDetail({ id }) {
        return super.get('/getDeferredReviewApplyDetail', { id });
    }

    submit({ id, applyStatus, auditOpinion, notPassIds } = {}) {
        return super.post('/submit', {
            id,
            applyStatus,
            auditOpinion,
            notPassIds,
        });
    }

    cancel({ id } = {}) {
        return super.post('/cancel', {
            id,
        });
    }

    applyMaterialsAudit({ id, applyMaterialsIds, applyMaterialsStatus } = {}) {
        return super.post('/applyMaterialsAudit', {
            id,
            applyMaterialsIds,
            applyMaterialsStatus,
        });
    }

    applyMaterialsDetail({ deferredReviewApplyId, applyMaterialsId }) {
        return super.get('/applyMaterialsDetail', { deferredReviewApplyId, applyMaterialsId });
    }

    saveApplyMaterials({ deferredReviewApplyId, applyMaterialsId, applyMaterialsValue }) {
        return super.post('/saveApplyMaterials', { deferredReviewApplyId, applyMaterialsId, applyMaterialsValue });
    }

    editDeliveryInfo({
        id,
        shipMethod,
        deliveryConsignee,
        deliveryPhone,
        deliveryRegionId,
        deliveryAddress,
        companyName,
        workRegionId,
    }) {
        return super.post('/editDeliveryInfo', {
            id,
            shipMethod,
            deliveryConsignee,
            deliveryPhone,
            deliveryRegionId,
            deliveryAddress,
            companyName,
            workRegionId,
        });
    }

    relatedGrouping({ ids, deferredReviewGroupingId } = {}) {
        return super.post('/relatedGrouping', {
            ids,
            deferredReviewGroupingId,
        });
    }

    transferGrouping({ ids, deferredReviewGroupingId, oldDeferredReviewGroupingId } = {}) {
        return super.post('/transferGrouping', {
            ids,
            deferredReviewGroupingId,
            oldDeferredReviewGroupingId,
        });
    }

    batchSetMaterialsTimeout({ deferredReviewGroupingId, ids, materialsIds }) {
        return super.post('/batchSetMaterialsTimeout', { deferredReviewGroupingId, ids, materialsIds });
    }

    addRemarks({ deferredReviewApplyId, remarks }) {
        return super.post('/addRemarks', { deferredReviewApplyId, remarks });
    }
}

export default new DeferredReviewApply();
export { DeferredReviewApply };
